export default __webpack_public_path__ + "static/media/emptyevents.ea49fa83.svg";